// @flow
import { combineReducers, type Reducer } from "redux";
import myAbsences, { initialState as myAbsencesInitialState } from "./my-absences";
import myDetails, { initialState as myDetailsInitialState } from "./my-details";
import myAbsenceStage, { initialState as myAbsenceStageInitialState } from "./my-absence-stage";
import myEmployees, { initialState as myEmployeesInitialState } from "./my-employees";
import type { ProfileState } from "./types";

export const initialState = {
  myAbsences: myAbsencesInitialState,
  myDetails: myDetailsInitialState,
  myAbsenceStage: myAbsenceStageInitialState,
  myEmployees: myEmployeesInitialState,
};

export default (combineReducers({
  myAbsences,
  myDetails,
  myAbsenceStage,
  myEmployees,
}): Reducer<ProfileState, *>);
